<template>
  <div>
    <van-field v-model="selectText" :label="dModel.label" :placeholder="options.placeholder" type="text" :is-link="true"
      :readonly="true" :maxlength="options.maxlength" :rules="dModel.rules" @focus="onFocus" />
    <div class="van-hairline--bottom"></div>
    <van-action-sheet v-model="show" name="abc" title="请选择" class="action-sheet-box">
      <van-search v-model="search" placeholder="请输入关键词" @input="OnInput"></van-search>
      <van-cell v-for="(item,index) in optionsList.filter(obj=>obj[labelKey].indexOf(search)!=-1)" :key="index"
        :title="item[labelKey]" :is-link="true" @click="onSelect(item)">
        <!--      <template #title>
          <span class="custom-title">{{item[labelKey]}}</span>

        </template> -->
        <template #right-icon>
          <div class="select-cell-box">
            <van-tag type="primary" class="cell-tag" v-if="selectValue.indexOf(item[valueKey])!=-1">已选择</van-tag>
            <van-icon name="arrow" />
          </div>
        </template>
      </van-cell>
    </van-action-sheet>
  </div>

</template>

<script>
  import formDesignMixins from './mixins/formDesignMixins'
  export default {
    name: "DesignSelect",
    data() {
      return {
        selectValue: [], // 选中的id值
        search: "",
        labelKey: "label", // label对应得属性key
        valueKey: "value", // value对应的属性key
        optionsList: [],
        show: false,
        multiple: this.options.multiple // 是否多选模式
      };
    },
    computed: {
      // 选中的文本值
      selectText() {
        let that = this
        // 文本记录数组
        let labelList = []
        // 循环下拉
        that.optionsList.forEach(function(item) {
          if (that.selectValue.indexOf(item[that.valueKey]) != -1) {
            labelList.push(item[that.labelKey])
          }
        })
        return labelList.toString()
      }
    },
    mixins: [formDesignMixins],
    props: {
      value: {
        default: ""
      },
      options: {
        type: Object,
        default: function() {
          return {
            width: "100%", // 宽度
            defaultValue: undefined, // 下拉选框请使用undefined为默认值
            multiple: false, // 是否允许多选
            disabled: false, // 是否禁用
            clearable: false, // 是否显示清除按钮
            hidden: false, // 是否隐藏，false显示，true隐藏
            placeholder: "请选择", // 默认提示文字
            valueKey: 'value',
            tooptip: '', // 提示
            dynamic: 0, // 数据获取方式
            remoteFunc: '', //远程获取数据链接
            dataPath: '',
            remoteValue: '',
            remoteLabel: '',
            linkage: false,
            options: [
              // 下拉选择项配置
              {
                value: "1",
                label: "下拉框1"
              }
            ],
            showSearch: false // 是否显示搜索框，搜索选择的项的值，而不是文字
          }
        }
      }
    },
    methods: {
      onFocus: function() {
        this.show = true
      },
      //搜索框变化事件
      OnInput: function() {
        //this.LoadItem()
      },
      change: function(selVal) {
        let valueEmit = selVal
        // 选中值类型为string,为单选模式
        if (typeof(selVal) != "string") {
          valueEmit = selVal.toString()
        }
        this.$emit('input', valueEmit)
      },
      onSelect: function(item) {
        let that = this
        this.show = false
        let itemValue = item[that.valueKey]
        //多选模式,判断是否重复
        if (that.multiple) {
          // 多选模式，如果是已选择项目，需要取消选中状态
          // 获得选中项目对应的下标索引
          let selIndex = that.selectValue.indexOf(itemValue)
          // 不存在,推入
          if (selIndex == -1){
            that.selectValue.push(itemValue)
          }else{
            //存在，删除当前选中对象
            that.selectValue.splice(selIndex,1)
          }
        } else {
          that.selectValue = [itemValue]
        }
        
        // this.selectText = item[that.labelKey]
        this.$emit('input', this.selectValue.toString())
      },
      //获得下拉列表
      initData: function() {
        let that = this
        // dynamic 为静态下拉，数据从配置中去抓取
        if (that.options.dynamic == 0) {
          that.optionsList = that.options.options
          return;
        }

        // dynamic 不为0 , 动态下拉
        this.valueKey = that.options.remoteValue
        this.labelKey = that.options.remoteLabel
        // 根据模型对象，获得远程数据
        let promiseOptions = that.$designUtils.getRemoteData(that.options)
        promiseOptions.then(data => {
          // 赋值
          that.optionsList = data
        })
      },
    },
    watch: {
      value(nv) {
        // 多选模式，处理数据
        this.selectValue = nv ? nv.split(",") : []

      },
    },
    mounted: function() {
      this.selectValue = this.value ? this.value.split(",") : []
      this.initData()
    },
  };
</script>

<style scoped="scoped">
  .active-cell {
    background-color: #0260F5;
    color: #fff;
  }

  .select-cell-box {
    display: flex;
    align-items: center;
  }

  .cell-tag {
    margin-right: 5px;
  }
</style>
